module.exports = __webpack_public_path__ + "static/media/leetcode.a73d2626.png";